// Cutover (M2, migration 033): orders placed before HHL Ops aren't on any PO here and Shopify doesn't show
// them as incoming, so until they're re-entered the plan may suggest ordering that stock again. Both plans say so until
// someone marks them entered (planning_settings.prior_orders_entered; planning settings can bring the note back).
import { AlertTriangle } from "lucide-react";
import { isOpen } from "../../../shared/po.ts";
import { can } from "../lib/mutate.ts";
import { saveSettings } from "../lib/planning.ts";
import { Link } from "../lib/router.tsx";
import { useRows } from "../lib/sync.ts";
import { Button } from "../ui/controls.tsx";

export function CutoverBanner() {
  const settings = useRows("planning_settings")[0];
  const pos = useRows("po");
  if (!settings || settings.prior_orders_entered) return null;
  const live = pos.filter((p) => p.kind !== "service" && isOpen(p.status));
  const drafts = live.filter((p) => p.status === "draft").length;
  const sent = live.length - drafts;
  const done = () =>
    confirm("Are the open orders placed before HHL Ops all on POs here now? This hides the note on both plans (planning settings bring it back).") &&
    saveSettings({ prior_orders_entered: true });
  return (
    <div className="flex items-start gap-2 border-b border-line bg-warn-soft px-4 py-2 text-[12px] text-warn">
      <AlertTriangle className="mt-0.5 size-4 shrink-0" />
      <div className="min-w-0 flex-1">
        Orders placed before HHL Ops (paid in Wise, on paper, by email) aren't on any PO here, and Shopify doesn't show them as incoming, so the plan may
        suggest ordering that stock again. Put each one still open on a PO:{" "}
        <Link to="/pos" className="font-medium underline">
          Purchase orders
        </Link>{" "}
        → New PO → Paste lines from the vendor's PI or your sheet (a build at a CM: a make PO, its builds on the Make tab). Then Mark as sent, not Send to
        vendor: they have it already (a warning that the plan says otherwise is expected: go ahead). Sent, one shipping to HHL shows as incoming in Shopify.
        Here so far: {sent} open PO{sent === 1 ? "" : "s"}
        {drafts ? `, ${drafts} draft${drafts === 1 ? "" : "s"}` : ""}.
      </div>
      {can("planning_settings.update") && (
        <Button size="sm" onClick={done}>
          They're all entered
        </Button>
      )}
    </div>
  );
}
